/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerShowResponse2 } from '../../models/customer-show-response-2';

export interface GetCustomerShow$Params {
  id: string;
}

export function getCustomerShow(http: HttpClient, rootUrl: string, params: GetCustomerShow$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, getCustomerShow.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerShowResponse2>;
    })
  );
}

getCustomerShow.PATH = '/v1/customer/{id}';
